import {defineStore, mapActions} from 'pinia';
import ArtistService from "../services/ArtistService";
import CommonServices from "../services/CommonServices";
import AdminService from "../services/AdminService";

export const useArtistStore = defineStore('ArtistStore', {
    state: () => {
        return {
            artist: null,
            artistId: null,
            artistGeneralInfo: {},
            artistPhotos: [],
            currencyList: [],
            artistCategory: [],
            groupMembers: [],
            regions: [],
            companies: [],
            currentUser: null,
            adminPermissions: false,
            basic: {
                stage_name: null,
                supplemental_title: null,
                artist_categories: [],
                artist_subcategories: [],
            },
            profileDetails: {
                companies: null,
                agreement: null,
                agreement_date_sign: null,
                user_languages: [],
                other_user_languages: null,
                bio: null,
                billing_information: null
            },
            locationInfo: {
                airport: null,
                alternative_airport: null,
                global_region: null,
            },
            performanceDetails: {
                minutes_in_material: null,
                available_shows: null,
                offer_adult: null,
                require_house_band: null,
                use_animals: null,
                animals_type: null,
                use_pyrotechnics: null,
                pyrotechnics_type: null,
                equipment_shipping: null,
            },
            repertoireInformation: {
                title: null,
                description: null,
                shows: [],
                quotes: [],
            },
            personalInfo: {
                first_name: null,
                last_name: null,
                birthday: null,
                place_of_birth: null,
                home_phone: null,
                cell_phone: null,
                website: null,
                cabins: null,
            },
            emergencyInfo: {
                contact_name: null,
                relationship: null,
                phone: null,
                vaccinations: null,
            },
            addressInfo: {
                line1: null,
                line2: null,
                city: null,
                state: null,
                country: null,
                zip: null,
            },
            passportInfo: {
                legal_name: null,
                number: null,
                date_of_issue: null,
                date_of_expiry: null,
                nationality: null,
                place_of_issue: null,
                visa_photo: null,
                passport_photo: null,
                residency_card_photo: null,
            },
            bankInfo: {
                bank_name: null,
                account_type: null,
                currency: null,
                account_number: null,
                bank_routing: null,
                name_on_account: null,
                address_associated: null,
                tax_id: null,
                intermediary_bank: null,
                sort_code: null,
                irc: null,
                terms_and_condition: null,
                w_9_form: null
            }
        }
    },
    getters: {
        sortedPhotos(state) {
            return [...state.artistPhotos].sort((a, b) => a.order - b.order);
        },
        companyIds(state) {
            return state.profileDetails.companies.map(company => company.id);
        }
    },

    actions: {
        updateArtistPhotos(newPhotos) {
            this.artistPhotos = [...newPhotos];
        },
        updatePhotoOrder(newOrderPhotos) {

            newOrderPhotos.forEach((id, index) => {
                const photo = this.artistPhotos.find((photo) => photo.id === id);
                if (photo) {
                    photo.order = index + 1;
                }
            });
        },
        async fetchArtistCategory() {
            try {
                const response = await ArtistService.getArtistCategory();
                this.artistCategory = response.data;
            } catch (e) {
                console.log(e)
            }
        },

        async fetchCompanies() {
            try {
                const { data: response } = await CommonServices.getCompanies()
                this.companies = response
            } catch (e) {

            }
        },
        async fetchArtist(artistId) {
            const uploadMethod = artistId
                ? AdminService.getArtistInfo(artistId)
                : ArtistService.fetchArtistInfo()

            try {
                const response =  await uploadMethod
                this.artist = response.data;
                this.artistGeneralInfo = response.data.user
                this.artistId = response.data.id
                this.updateFormFields(this.profileDetails)
                this.updateFormFields(this.locationInfo)
                this.updateFormFields(this.performanceDetails)
                this.updateBasic()
                if (this.artist.personal_info) {
                    this.fulfillPersonalInfoFields(this.personalInfo)
                    this.fulfillPersonalInfoFields(this.emergencyInfo)
                    this.fulfillPersonalInfoFields(this.addressInfo)
                    this.fulfillPersonalInfoFields(this.passportInfo)
                }
                this.groupMembers = this.artist.group_members
                this.bankInfo = this.artist.bank_info ?? {}
                this.artistPhotos = response.data.photos
                this.personalInfo.first_name = this.artist.user.first_name
                this.personalInfo.last_name = this.artist.user.last_name
                this.personalInfo.cell_phone = this.artist.user.phone
                this.personalInfo.email = this.artist.user.email
                if (this.artist.shows) {
                    this.repertoireInformation = this.artist.shows
                }

            } catch (error) {
                console.error('Помилка отримання даних артиста:', error);
            }
        },
        updateBasic() {
            this.basic.stage_name = this.artist.stage_name
            this.basic.supplemental_title = this.artist.supplemental_title
            this.basic.artist_categories = this.artist.categories.map(cat => cat.id);
            this.basic.artist_subcategories = this.artist.subcategories.map(cat => cat.id);
            console.log( this.basic.artist_categories)
            console.log(this.basic.artist_subcategories)
        },
        updateFormFields(form) {
            Object.keys(form).forEach((key) => {
                form[key] = this.artist[key] ?? null;
            });
        },
        fulfillPersonalInfoFields(form) {
            Object.keys(form).forEach((key) => {
                form[key] = this.artist.personal_info[key] ?? null;
            });
        },

        setAdminPermission() {
            this.adminPermissions = true
        },

        async getCurrentUser() {
            try {
               const { data: response } = await CommonServices.getLoggedUser()
                this.currentUser = response
            } catch (e) {
               console.error(e)
            }
        },

        async getCurrencyList() {
            try {
                const {data: response} = await CommonServices.getCurrencyList()
                this.currencyList = response
            } catch (e) {
            }
        },
        async fetchRegionList() {
            try {
                const { data: response } = await CommonServices.getRegionsList();
                this.regions = response
            } catch (e) {
                console.error(e);
            }
        }
    },
})
